import React from 'react'
import LuxPlusLandingPartnerOffersList from './LuxPlusLandingPartnerOffersList'
import LuxPlusLandingBottomCTA from './LuxPlusLandingBottomCTA'

function LuxPlusLandingPartnerOffersTabSection() {
  return (<>
    <LuxPlusLandingPartnerOffersList />
    <LuxPlusLandingBottomCTA />
  </>)
}

export default LuxPlusLandingPartnerOffersTabSection
